<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title">Houx et Amour</h1>
<h1>Auteure à Succès USA Today</h1>
<h1>Amanda Mariel</h1>
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></div><p class="first-in-chapter" style="page-break-before: always"><span class="first-chapter-phrase"><span class="drop-cap">C</span>eci est une œuvre</span> de fiction. Les noms, personnages, lieux, évènements et incidents sont le fruit de l’imagination de l’auteure et sont fictifs.</p>
<p style="text-align: center; text-indent: 0">Copyright © 2019 Amanda Mariel</p>
<p style="text-align: center; text-indent: 0">Tous droits réservés.</p>
<p>Sans l’autorisation expresse écrite de l’éditeur, aucune partie de ce livre ne peut être reproduite, stockée ou transmise, quel que soit le moyen utilisé : électronique, mécanique, photographique, enregistrement ou autres.</p>
<p style="text-align: center; text-indent: 0">Publié par Brook Ridge Press</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?8d2b482a